"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.blockToHtml = blockToHtml;
exports.getEmojis = getEmojis;
exports.matchEmoji = matchEmoji;
var _lodash = require("lodash");
var _state = _interopRequireDefault(require("@/libs/state"));
function matchEmoji(word) {
  const emojis = this.getEmojis(word);
  if (!emojis.length) {
    return false;
  }
  return [{
    index: 0,
    match: word,
    type: 'emoji',
    meta: {
      emoji: emojis[0].code
    }
  }];
}
function blockToHtml(block, isSingle, showEmoticons) {
  if (!showEmoticons) {
    return block.content;
  }
  const emojiLocation = (0, _state.default)().setting('emojiLocation');
  const emoji = block.meta.emoji;
  const classes = 'kiwi-messagelist-emoji' + (isSingle ? ' kiwi-messagelist-emoji--single' : '');
  const src = `${emojiLocation}${emoji}`;
  return `<img class="${classes}" src="${src}" alt="${(0, _lodash.escape)(block.content)}" title="${(0, _lodash.escape)(block.content)}" />`;
}
function getEmojis(word) {
  const emojiList = (0, _state.default)().setting('emojis');
  const emojiLocation = (0, _state.default)().setting('emojiLocation');
  if (!Object.prototype.hasOwnProperty.call(emojiList, word)) {
    return [];
  }
  return [{
    ascii: word,
    code: emojiList[word],
    url: emojiLocation + emojiList[word]
    // imgProps allows setting properties of <img>
  }];
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["EmojiProvider"]
window._kiwi_exports.libs.EmojiProvider = exports.default ? exports.default : exports;
